<template>
  <div class="card__wrap">
    <div class="card__info">
      <div class="card__left">
        <img class="card__avatar" :src="cardInfo.avatar" @click="clickAvatar" />
        <p v-if="cardInfo.position && cardInfo.position.length <= 6" class="card__position">
          <span>{{ cardInfo.position }}</span>
        </p>
      </div>
      <div class="card__right">
        <div class="card__name__logo">
          <p class="card__name" v-if="cardInfo.name">
            {{ cardInfo.name.length > 6 ? `${cardInfo.name.substring(0, 6)}...` : cardInfo.name }}
          </p>
          <img
            v-if="globalStore.isManagerView"
            class="card__edit"
            @click="clickEditBtn"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAABSJJREFUaEPVmv1vU1UYx7+n67punYOVARtjyMZI9mZFMgU1m2wLKipEUTEjcQn4AyYzGH/xN/8GomGJmuCSxYz4hgR8AckmlIgsWRDXjS3uDfc+GO0Y617bHvOU29nV295z297Ne5Imy+5znvt8zjn3Oc9znsMQp8Y5XwMgF0AWgAwA6QDMAJKkV8wDmAPgAjABYBRAP2PsfjxMYLEo4ZyvBWCTfmR8NI2g2ujHGJuMRgH1iQqEc54JoAxAUbQ6ZAzmAG4BuMoYG1MLpAqEc24BsBfA43EECLWZgP4EcIkx5hYFEgbhnJcAeBlAsqjyGOVmAfzIGGsX0aMIwjlPALAPQKmIQg1kWgH8zBjzRtIdEYRzbgLwFoBtGhioRmUvgK8YYwvhOoUFkSBqAGxW80YNZYcANISDkQWRltPh/8FMhI4LzUyj3DILB/LKKn4TSpPayhj7IVToPyCSd3pDSdsqP/821JstA5H2ifdW0MVGOx7kmk8G7zOhIK8C2KGkfWH2ftJ4l73YMz/9iJJs4Lkp1erMLtnrAAxhuwy3X3yMHmaXvOAQ0HuTMXY2ILcEIoUdx5R2bILo/OWTY56FGQoKVbXMwj1nwhn5l/3UvgfjPU+RwkhyQS+kCOCzQDgTDPImgGIlywb/OL/zTs+1/Upycs/DGdh3vbHcNeioCPQRBCHxDsbYN/SHH0SKYt9Xmg2S7b9++jnnYNse+tucmnE7JX3TbRGocEtr4Ma50om+31/i/KEtFutmR0FV7RkRnWQ6gI8pag6AlAOoFOkcDGLNsV3O3V19RaSfnMzoraai0Y6m1zm4/8Mxp23oKayqPW0wmnwqdDYzxuwBEPJUQvlEvEDu9rbkDt48d5j7fEYy2mRZO1RYWdtgNKcuqoAg0QnG2EkmZXYfiHaOB4hzoG3T361f1/i8Xn/2aDSn3i2ofLc+ybKO3Go07QSBkLsltyvUYgWZGu9Z1/dbwxGvd5FyGxhNyZP5Ze/UW6zZU0IGyAudJRAK0XeJKokFxO0cTuu2nzrqXZyl/B4JCYnuvGdr6tM25t8TfX8YuRYCeVtNcBgtyLz7XnJX86dHPHPT68kYQ0LC/KOlhxqsW2wjMUJQ914CIbcrvLlFA+KZm07sbK6rWXBP+lMCZjB4cnYcaFy/bVf/vxA+DLdfknb2yBGADLiLQD4EkCI6KmpBfJ4FQ1dTXfXs1J18PwSYL6u46rusoio6aFhqFJ6MdV4+SP9QsSEG+s8QyEe0XLUC6WqqO+h2DvlHmjHwjLynf9qy8wClr8ua2gEK6e7VFKT76hcvTo11LzmS9Bzbr3m7q+1ygxYPEE2W1ojjgm2068prAaPTMre3bC87eiHczMcI4l9axwFY4720+q59WeEa7qDQRyh+ihHEqZn7JXc70Pp9hcFknsl98pBdKX6KEcTvfldsQ4w06zGC+DfEFQ1RNPpG/CEKhQsrGjRq4LVOrFoYH8d95GEYTwo556uSWAXDxPCNLEusqGCjaaqr5N5nXCNb56YntpKcisxzeaorzYrmhw9KMIHnG/KfOZ/zxP4bAvLLDx8kEKpCaXocJGAYEk0pzoLnj39uSl5DNcdITf44SILR7IBOBMKYlPpgY0F5hwAEqZM/oJNAKP3U/5GpBEMlNn0fYgemn3Ou/7KCNCuUaOm/0CPBUP1Q36W3oCWm/2JoEIz+y9PBvl/3FwZCYPR/hSMESN+XakLDDN1fc5KLm2QuntHJDJUNgi+eUSDo1OLi2T/e+QLD1FMY2QAAAABJRU5ErkJggg=="
          />
          <img class="card__logo" :src="cardInfo.corpLogo" />
        </div>
        <p v-if="cardInfo.position && cardInfo.position.length > 6" class="card__position">{{ cardInfo.position }}</p>
        <div class="card__corp__dept">
          <span>{{ cardInfo.corpName }}</span>
          <template v-if="cardInfo.deptList && cardInfo.deptList.length">
            <template v-for="(item, index) in cardInfo.deptList" :key="index">
              <span v-if="cardInfo.corpName" class="card__dept">{{ item }}</span>
              <span v-else :class="index === 0 ? '' : 'card__dept'">{{ item }}</span>
            </template>
          </template>
        </div>
        <div v-if="cardInfo.tagList && cardInfo.tagList.length" class="card__tag">
          <div v-for="(item, index) in cardInfo.tagList" :key="index" class="card__tag__item">{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="card__divider"></div>
    <div class="card__desc" v-if="cardInfo.desc">
      <BaseIconSvg type="czliangdian" color="#391E00"></BaseIconSvg>
      <div>
        <p v-for="(item, index) in cardInfo.desc.split('\n')" :key="index">
          {{ item }}
        </p>
      </div>
    </div>
    <div class="card__address" v-if="cardInfo.address">
      <BaseIconSvg type="czdizhi" color="#391E00"></BaseIconSvg>
      <p>{{ cardInfo.address }}</p>
    </div>
    <template v-if="cardInfo.certificateList && cardInfo.certificateList.length">
      <CertificateBanner :certificateList="cardInfo.certificateList" indicatorColor="#CCAA78" />
    </template>
  </div>
</template>

<script setup lang="ts">
  import { useBusinessCardStore, useGlobalStore } from '@shared/store';
  import { BaseIconSvg } from '@shared/components';
  import { storeToRefs } from 'pinia';
  import { computed, reactive, ref } from 'vue';
  import CertificateBanner from '../certificate-banner/index.vue';
  import { useAvatar, useCard } from '../../composables';

  const globalStore = useGlobalStore();
  const { clickAvatar } = useAvatar();
  const { clickEditBtn } = useCard();

  const cardStore = useBusinessCardStore();

  const { pageCardInfo: cardInfo } = storeToRefs(cardStore);
</script>

<style lang="less" scoped>
  @positionBgImg: 'data:image/png;base64,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';

  .card__wrap {
    padding: 0.4rem 0.3rem 0.63rem;
    width: 100vw;
    margin-left: -0.2rem;
    margin-top: -0.2rem;
    background-image: url('https://webcdn.tengmoney.com/usm/FuOf9GoY20E8DxD_Hs7OP96WCxCo-750-710.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .card__info {
      display: flex;
      align-items: flex-start;
      width: 100%;
      overflow: hidden;
      .card__left {
        position: relative;
        margin-right: 0.35rem;
        .card__avatar {
          width: 1.32rem;
          height: 1.32rem;
          border-radius: 50%;
        }
        .card__position {
          position: absolute;
          z-index: 1;
          width: 100%;
          bottom: 0;
          text-align: center;
          font-size: 12px;
          font-weight: 600;
          color: #995505;
          text-shadow: 0 0.06rem 0.09rem rgba(136, 109, 53, 0);
          background: url(@positionBgImg) no-repeat;
          background-size: 100% 0.33rem;
          line-height: 14.5px;
          height: 16.5px;
          white-space: nowrap;
          span {
            transform: scale(0.67);
            display: inline-block;
            margin-left: -0.06rem;
          }
        }
      }
      .card__right {
        flex: 1 0 auto;
        max-width: 4.8rem;
        .card__name__logo {
          margin-bottom: 0.2rem;
          display: flex;
          align-items: center;
          .card__name {
            font-size: 20px;
            font-weight: 500;
            color: #000000;
            line-height: 1;
          }
          .card__edit {
            width: 0.5rem;
            height: 0.5rem;
            margin-left: 0.1rem;
          }
          .card__logo {
            margin-left: 0.2rem;
            max-height: 0.34rem;
          }
        }
        .card__position {
          font-size: 12px;
          font-weight: 500;
          color: #755928;
          line-height: 1.375;
          margin-bottom: 0.1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .card__corp__dept {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
          font-weight: 400;
          color: #755928;
          line-height: 1.375;
          margin-bottom: 0.2rem;
        }
        .card__dept {
          &::before {
            content: '|';
            padding: 0.05rem;
          }
        }
        .card__tag {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .card__tag__item {
            background: #b5936e;
            border-radius: 0.08rem;
            font-size: 12px;
            font-weight: 400;
            color: #ffffff;
            padding: 0.06rem 0.15rem;
            margin-right: 0.1rem;
            margin-bottom: 0.2rem;
          }
        }
      }
    }
    .card__divider {
      height: 0.02rem;
      background: #896624;
      margin-bottom: 0.2rem;
    }
    .card__desc {
      margin-bottom: 0.2rem;
      font-size: 12px;
      font-weight: 400;
      color: #391e00;
      line-height: 1.33;
      display: flex;
      flex-wrap: nowrap;
      align-items: flex-start;
      svg {
        height: 0.32rem;
        flex: 0 0 0.29rem;
        margin-top: 0.04rem;
      }
      p {
        flex: 1 1 auto;
        margin-left: 0.1rem;
      }
    }
    .card__address {
      margin-bottom: 0.3rem;
      font-size: 12px;
      font-weight: 400;
      color: #391e00;
      line-height: 1.33;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      svg {
        height: 0.32rem;
        flex: 0 0 0.29rem;
      }
      p {
        flex: 1 1 auto;
        margin-left: 0.1rem;
      }
    }
  }
</style>
